export default function mibToGib(mib: string | number): number {
  const mibValue = Number.parseFloat(mib as string);
  const gib = mibValue / 1024;

  if (mibValue % 1024 > 0) {
    return Number.parseFloat(gib.toFixed(1));
  }
  return gib;
}
